import { useTranslation } from "react-i18next";
import { useConnectionStore, type ConnectionStatus } from "../state/connectionStore.js";
import { useRoundStore, selectOnlinePlayers } from "../state/roundStore.js";

const STATUS_TOKEN: Record<ConnectionStatus, string> = {
  connected: "var(--cx-color-success)",
  connecting: "var(--cx-color-warning)",
  reconnecting: "var(--cx-color-warning)",
  disconnected: "var(--cx-color-danger)",
  idle: "var(--cx-color-muted)",
};

/** Socket + clock health. Phase 0 DoD: the page shows the state of the socket. */
export function ConnectionBadge() {
  const { t } = useTranslation();
  const status = useConnectionStore((s) => s.status);
  const latencyMs = useConnectionStore((s) => s.latencyMs);
  const clockSynced = useConnectionStore((s) => s.clockSynced);
  const online = useRoundStore(selectOnlinePlayers);

  const labelKey = status === "idle" ? "connection.connecting" : "connection." + status;

  return (
    <div className="flex items-center gap-3 text-sm" style={{ color: "var(--cx-color-muted)" }}>
      <span className="flex items-center gap-2">
        <span
          aria-hidden="true"
          className="inline-block h-2 w-2 rounded-full"
          style={{ background: STATUS_TOKEN[status] }}
        />
        {t(labelKey)}
      </span>
      {clockSynced ? <span>{t("connection.latency", { ms: Math.round(latencyMs) })}</span> : null}
      <span>{t("bets.count", { count: online })}</span>
    </div>
  );
}
